import axios from 'axios';
import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { API } from '../../../config/API';
import ToastComp from '../../../components/Toast/Toast';
import Loader from '../../../components/Loader/Loader';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';


function AssignUser(arg) {
  const [show, setShow] = useState(arg.flag);
  const [activityList, setActivityList] = useState([]);
  const [activityId, setActivityId] = useState('');
  const [loader, setLoader] = useState(false);
  const [toastToggle, setToastToggle] = useState(false);
  const [errorToggle, setErrorToggle] = useState(false);
  const [expiryDate, setExpiryDate] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)));
  const [todayDate, setTodayDate] = useState(new Date());
  const activityType = useRef('');

  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);

  const getActivityList =(val)=>{
    axios.get(API.listActivity+val).then((resp)=>{
      if(resp.data && resp.data.status === 'S'){
        const obj = resp.data;
        activityType.current = val;
        setActivityList(obj[val]);
      }
    }).catch((er)=>{

    });
  }

  const assignActivity=()=>{
    let api;
    setShow(false);
    const req = {
      userId : arg.user,
      dueDate : expiryDate.toISOString().split('T')[0]
    }
    if(activityType.current === "trainings"){
      api = API.assignTrainingToUser;
      req.trainingId = activityId;
    }else if(activityType.current === "communications"){
      api = API.assignCommunicationToUser;
      req.communicationId = activityId;
    }else if(activityType.current === "assessments"){
      api = API.assignAssessment;
      req.assessmentId = activityId;
    }
  
    setLoader(true);
    axios.post(api,req).then((resp)=>{
      if(resp.data && resp.data.status === 'S'){
        // setToastToggle(true);
        toast.success('Activity assigned successfully.');
      }else{
        // setErrorToggle(true);
        toast.error('Failed to assign activity.');
      }
    }).catch((er)=>{
      // setErrorToggle(true);
      toast.error('An error occurred while assigning activity.');
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false);
        arg.handler();
      }, 1000);
    })


  }

  return (
    <>
      <Loader loading={loader}></Loader>
      {toastToggle ? <ToastComp case='assign-user' handler={()=>{setToastToggle(false)}}/> : ""}
      {errorToggle ? <ToastComp case='error' handler={()=>{setErrorToggle(false)}}/> : ""}
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Assign Activity Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Select Activity Type</Form.Label>
              <select className='form-control' onChange={(e)=>getActivityList(e.target.value)}>
                <option></option>
                <option value='communications'>Communication</option>
                <option value='assessments'>Assessment</option>
                <option value='trainings'>Training</option>
              </select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Select Activity</Form.Label>
              <select className='form-control' onChange={(e)=>setActivityId(e.target.value)}>
                <option></option>
                {
                  activityList.map((item)=>{
                    return(
                      <option key={item.id} value={item.id}>{item.name}</option>
                    )
                  })
                }
              </select>
          </Form.Group>
          <Form.Group
              className="mb-3 mt-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Due Date</Form.Label>
              <DatePicker dateFormat="yyyy/MM/dd" minDate={todayDate} selected={expiryDate} onChange={(date) =>{ setExpiryDate(date)}} className='form-control'/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
          <Button variant="primary" onClick={assignActivity}>
            ASSIGN
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AssignUser;

